module.exports = __webpack_public_path__ + "static/media/personGroup.e38ca2ac.svg";